/* eslint-disable jsx-a11y/accessible-emoji */
import * as React from 'react';

import { IngridLogo, Text } from './commons/components';
import { Stack } from './commons/components/layout/stack';
import { GlobalStateContext } from './global-state';
import { colors } from './theme/colors';
import { fontStyles } from './theme/fontStyles';

export const RussiaAlert: React.FC = () => {
  const globalState = React.useContext(GlobalStateContext);

  if (!globalState) {
    return null;
  }

  const session = globalState.sessions[0];

  const { enable_widget_border, enable_transparent_background } = session.flags;

  return (
    <div
      css={{
        border: enable_widget_border ? `1px solid ${colors.neutral90}` : undefined,
        borderRadius: '6px',
        backgroundColor: enable_transparent_background ? 'transparent' : 'white',
        padding: '16px',
      }}
    >
      <Stack space="16px" alignX="center">
        <Text display="block" css={{ ...fontStyles.px20_28 }} aria-label="img">
          💙 💛
        </Text>
        <Text css={{ textAlign: 'center', ...fontStyles.px14_20 }}>
          {globalState.locale.toLowerCase() === 'ru-ru' ? textUpperRU : textUpperUS}
        </Text>
        <Text css={{ textAlign: 'center', ...fontStyles.px14_20 }}>
          {globalState.locale.toLowerCase() === 'ru-ru' ? textLowerRU : textLowerUS}
        </Text>
        <IngridLogo fill={colors.black} />
      </Stack>
    </div>
  );
};

RussiaAlert.displayName = 'RussiaAlert';

const textUpperUS =
  'We are not able to serve you with delivery options because your country has waged an illegitimate war on Ukraine. We are very sorry, we know you are too.';
const textLowerUS =
  'Ingrid’s delivery checkout is built by Ukrainians and we will not accept that it is being used for Russia.';
const textUpperRU =
  'Мы не можем предоставить Вам варианты доставки, потому что Ваша страна ведет незаконную войну с Украиной.  Нам очень жаль. Мы знаем, что вам тоже.';
const textLowerRU =
  'Продукты Ingrid разработаны в том числе украинцами, и мы не допустим того, чтобы они использовались на территории Российской Федерации';
